<!-- =========================================================================================
  File Name: LeaderboardList.vue
  Description: Leaderboard List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <h3 class="mr-3">Gamification</h3>
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2">{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  ListData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : ListData.length
                }}
                of {{ ListData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!--ADD Leaderboard-->
        <vs-button v-on:click="setupGame = true" class="mr-3"
          >Setup New Game</vs-button
        >
        <!-- <vx-tooltip text="Actions" position="bottom">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-3
                shadow-drop
                rounded-lg
                d-theme-dark-light-bg
                cursor-pointer
                flex
                items-end
                justify-center
                text-lg
                font-medium
                w-32
              "
            >
              <span class="leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu class="dropdown-width">
              <vs-dropdown-item @click="exportGameReport">
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Export Game Scores</span>
                </span>
              </vs-dropdown-item> 
            </vs-dropdown-menu>
          </vs-dropdown>
        </vx-tooltip> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="ListData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

    <vs-popup
      class="holamundo custom-activity-wrap custom-activity-pop"
      title="Setup a New Game"
      :active.sync="setupGame"
    >
      <div class="activity-wrap">
        <label>Game</label>
        <v-select
          v-model="selectedGame"
          class="mb-3"
          :options="games"
          disabled
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <label>Module</label>
        <v-select
          class="mb-3"
          v-model="selectedModule"
          :options="modules"
          disabled
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />

        <div class="score-wrap">
          <div style="text-align: center">
            <label>Default Score</label>
            <vs-input-number
              class="mr-3"
              color="#4c8bf6"
              v-model="minimumScoreGame"
            />
          </div>
          <div style="text-align: center">
            <label>Default Max score</label>
            <vs-input-number color="#4c8bf6" v-model="maximumScoreGame" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-6/12">
            <label> Before Play </label>
            <vs-input
              class="w-full mt-4"
              name="beforePlayTxt"
              v-model="beforePlayTxt"
            />
          </div>
          <div class="vx-col md:w-6/12">
            <label> After Play </label>
            <vs-input
              class="w-full mt-4"
              name="afterPlayTxt"
              v-model="afterPlayTxt"
            />
          </div>
          <div class="vx-col md:w-6/12">
            <label> Call to Action Message </label>
            <vs-input
              class="w-full mt-4"
              name="callToActionMessageTxt"
              v-model="callToActionMessageTxt"
            />
          </div>
          <div class="vx-col md:w-6/12">
            <label> Call to Action Button Text </label>
            <vs-input
              class="w-full mt-4"
              name="callToActionMessageButtonTxt"
              v-model="callToActionMessageButtonTxt"
            />
          </div>
          <div class="vx-col md:w-6/12">
            <label> Success message(after game play) </label>
            <vs-input
              class="w-full mt-4"
              name="successMessageTxt"
              v-model="successMessageTxt"
            />
          </div>
        </div>

        <div class="mt-5" style="text-align: right">
          <vs-button color="#4c8bf6" type="filled" @click="createNewGame"
            >Submit</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import ls from "@/common/localStorage";

// Store Module
import moduleLeaderboardManagement from "@/store/leaderboard-management/moduleLeaderboardManagement.js";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";

// Cell Renderer
import CellScore from "./cell-renderer/CellScore.vue";
import CellDisplayLabel from "./cell-renderer/CellDisplayLabel.vue";
import CellMaxScore from "./cell-renderer/CellMaxScore.vue";
import CellPublish from "./cell-renderer/CellPublish.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererGameActions from "./cell-renderer/CellRendererGameActions.vue";
import CellRendererGameEdit from "./cell-renderer/CellRendererGameEdit.vue";

export default {
  components: {
    AgGridVue,
    vSelect,

    CellScore,
    CellDisplayLabel,
    CellMaxScore,
    CellPublish,
    CellRendererActions,
    CellRendererGameActions,
    CellRendererGameEdit
  },
  data() {
    return {
      setupGame: false,
      gridApi: null,
      games: ["Scavenger Hunt"],
      modules: ["Exhibitor"],
      selectedGame: "Scavenger Hunt",
      selectedModule: "Exhibitor",
      minimumScoreGame: 10,
      maximumScoreGame: 100,
      beforePlayTxt: null,
      afterPlayTxt: null,
      callToActionMessageTxt: null,
      callToActionMessageButtonTxt: null,
      successMessageTxt: null,
      gridOptions: { suppressRowClickSelection: true },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      number6: 20,
      number7: 40,
      popupActive2: false,
      popupActive3: false,
      popupActive4: false,
      options: [
        { id: 1, label: "foo" },
        { id: 3, label: "Scavenger Hunt" },
        { id: 2, label: "baz" },
      ],
      selected: { id: 3, label: "Scavenger Hunt" },
      options: [
        { id: 4, label: "foo" },
        { id: 5, label: "Expo" },
        { id: 6, label: "baz" },
      ],
      selected2: { id: 5, label: "Expo" },
      columnDefs: [
        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          headerName: "Name of Game",
          field: "Name",
          filter: true,
          width: 450,
        },
        {
          headerName: "Module",
          field: "module",
          width: 450,
        },
        {
          headerName: "Export/Import",
          //field: "MaxActionScore1",
          cellRendererFramework: "CellRendererGameActions",
          cellRendererParams: (params) => {
            return params;
          },
        },
        /*{
          headerName: "Action",
          cellRendererFramework: "CellRendererGameEdit",
          cellRendererParams: (params) => {
            return params;
          },
        },*/
      ],
      settings: {
        DisplayScoreOnProfile: false,
      },
      Tabs: [
        {
          DisplayLabel: "Users",
          IsPublished: true,
          TabId: 1,
          TabName: "Users",
        },
        {
          DisplayLabel: "Groups",
          IsPublished: true,
          TabId: 2,
          TabName: "Groups",
        },
        {
          DisplayLabel: "My Achivements",
          IsPublished: true,
          TabId: 3,
          TabName: "My Achivements",
        },
      ],

      // Cell Renderer Components
      components: {
        CellScore,
        CellDisplayLabel,
        CellMaxScore,
        CellPublish,
        CellRendererActions,
        CellRendererGameActions,
        CellRendererGameEdit
      },
      popupUserList: false,
      attendessList: [],
      popupActive: false,
      color: "#4c8bf6",
      switch6: true,
      searchAttendeeText: "",
      clearAttendeeList: [],
      TextBoxShowingId: null,
      userIdList: [],
    };
  },
  watch: {},
  computed: {
    ListData() {
      return this.$store.state.LeaderboardManagement.scavengerHunt;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    createNewGame() {
      this.setupGame = false;
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/createNewGame", {
          selectedGame: this.selectedGame,
          selectedModule: this.selectedModule,
          minimumScoreGame: this.minimumScoreGame,
          maximumScoreGame: this.maximumScoreGame,
          beforePlayTxt: this.beforePlayTxt,
          afterPlayTxt: this.afterPlayTxt,
          callToActionMessageTxt: this.callToActionMessageTxt,
          callToActionMessageButtonTxt: this.callToActionMessageButtonTxt,
          successMessageTxt: this.successMessageTxt,
        })
        .then((res) => {
          this.$vs.loading.close();
          this.selectedGame = "Scavenger Hunt";
          this.selectedModule = "Exhibitor";
          this.minimumScoreGame = 10;
          this.maximumScoreGame = 100;
          this.beforePlayTxt = null;
          this.afterPlayTxt = null;
          this.callToActionMessageTxt = null;
          this.callToActionMessageButtonTxt = null;
          this.successMessageTxt = null;
          console.log("res---", res);
          if (res.status == 200) {
            this.$store.dispatch("LeaderboardManagement/fetchScavengerHunt");
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "Custom Activity Created successfully.",
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Custom Activity could not be created!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something Went Wrong!",
          });
        });
    },
    editGamePopup(gameData){
      this.selectedGame = gameData.Name
      this.selectedModule = gameData.module
      this.minimumScoreGame = gameData.Score
      this.maximumScoreGame = gameData.MaxScore
      this.beforePlayTxt = gameData.Meta.ButtonLabelBeforePlay
      this.afterPlayTxt = gameData.Meta.ButtonLabelAfterPlay
      this.callToActionMessageTxt = gameData.Meta.GameInfoAfterPlay
      this.callToActionMessageButtonTxt = gameData.Meta.GameInfoBeforePlay
      this.successMessageTxt = gameData.Meta.SuccessMessage

      this.setupGame = true
      //console.log(gameData)
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    
  },
  created() {
    if (!moduleLeaderboardManagement.isRegistered) {
      this.$store.registerModule(
        "LeaderboardManagement",
        moduleLeaderboardManagement
      );
      moduleLeaderboardManagement.isRegistered = true;
    }
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule("exhibitorManagement", moduleExhibitorManagement);
      moduleExhibitorManagement.isRegistered = true;
    }
    this.$store.dispatch("LeaderboardManagement/fetchScavengerHunt");
    this.$root.$on('editGamePopup', this.editGamePopup);
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>